import { isEmpty, sanitizeValues } from '@intelligence/v3/utils/common';
import { getDefaultUrlFieldMap, getItemUrlParamsFieldMap } from '../shared/fieldMapUtils';
import { buildStringArrayApiParamsByItem } from '../shared/valueUtils';

import type { IFilterMiddlewareUtils } from '../shared/types';
import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

const URL_FIELD_FALLBACK_MAP: IRecord<string> = {
  sensor_tower_tag_art_style: 'artStyle',
  sensor_tower_tag_camera_pov: 'cameraPov',
  sensor_tower_tag_product_model: 'productModel',
  sensor_tower_tag_setting: 'setting',
  sensor_tower_tag_tags: 'tag',
  sensor_tower_tag_monetization: 'monetization',
  appmagic_themes: 'appmagicThemes',
  appmagic_features: 'appmagicFeatures',
  appmagic_ip: 'appmagicIp',
  appmagic_settings: 'appmagicSettings',
  appmagic_art_styles: 'appmagicArtStyles',
};

const getUrlField = (item: IFilterItemConfig, params?: unknown): string => {
  const urlParamsFieldMap = getItemUrlParamsFieldMap(item, params);
  const defaultUrlFieldMap = getDefaultUrlFieldMap(params);

  return (
    urlParamsFieldMap.value || defaultUrlFieldMap.value || URL_FIELD_FALLBACK_MAP[item?.field] || item?.field || ''
  );
};

/**
 * 标签筛选器中间件工具
 * value 类型：string[]
 */
class TagSelectMiddlewareUtils implements IFilterMiddlewareUtils<string[], IRecord<string[]>> {
  convertToApiParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string[]> | null {
    return buildStringArrayApiParamsByItem(item, filterValue, params);
  }

  getManagedUrlKeys(item: IFilterItemConfig, params?: unknown): string[] {
    const field = getUrlField(item, params);

    return isEmpty(field) ? [] : [field];
  }

  deserializeUrlParams(item: IFilterItemConfig, searchParams: URLSearchParams, params?: unknown): string[] | null {
    if (isEmpty(searchParams)) {
      return null;
    }

    const field = getUrlField(item, params);
    const values = sanitizeValues((searchParams.get(field) || '').split(',').map((itemValue) => itemValue.trim()));

    return isEmpty(values) ? null : values;
  }

  serializeUrlParams(item: IFilterItemConfig, filterValue?: string[], params?: unknown): IRecord<string> | null {
    if (isEmpty(filterValue)) {
      return null;
    }

    const unique = sanitizeValues(filterValue);
    const field = getUrlField(item, params);

    if (isEmpty(unique) || isEmpty(field)) {
      return null;
    }

    return {
      [field]: unique.join(','),
    };
  }
}

export default TagSelectMiddlewareUtils;
